import {
  RegisterGcsPluginCallingHandler,
  CompleteReplayJournal,
  ConfirmReplayJournalPrecheck,
  LoadPublicComponent,
  PlacePublicComponent,
  LoadPublicComponentInBatch,
} from '@/core/gcsUtils'
import goToPageMixin from '@/mixins/goToPageMixin'
import checkLoginMixin from '@/mixins/checkLoginMixin'
export default {
  mixins: [checkLoginMixin, goToPageMixin],
  mounted() {
    this.registerReplayRecord()
  },
  methods: {
    registerReplayRecord() {
      RegisterGcsPluginCallingHandler({ id: 'GcsPluginCallingHandler', handler: this.GcsPluginCallingHandler })
    },
    /*
      @description 处理来自Gcs插件的调用的JS处理器
      @params method 要调用的JS方法名
      @params params 要调用的JS方法参数对象
      @
      @return a Promise. resolve结果为bool，若已处理(Handled)，则为true；否则，为false
      */
    async GcsPluginCallingHandler(method, params) {
      if (method === 'ReplayJournal') {
        this.handleReplayJournal(params).catch()
        return Promise.resolve(true)
      } 
      if (method === 'ReplayJournalPrecheck') {
        this.handleReplayJournalPrecheck(params).catch()
        return Promise.resolve(true)
      }           
      // 若增加新的接口给插件调用，可在此处扩展
      return Promise.resolve(false)
    },
    async handleReplayJournal(params) {
      const { actionName, actionArgs } = params
      let actionResult = {
        code: 'not set', 
        message: 'not set',
        data: false
      }
      const actionMethodsMapping = {
        GoToProductListPage: this.replayGoToProductListPage,
        GoToProductDetailPage: this.replayGoToProductDetailPage,
        GoToSelectionListPage: this.replayGoToSelectionListPage,
        LoadPublicComponentFromProducts: this.replayLoadPublicComponent,
        PlacePublicComponentFromProductsList: this.replayPlacePublicComponent,
        PlacePublicComponentFromProducts: this.replayPlacePublicComponent,
        PlacePublicComponentFromSelectionList: this.replayPlacePublicComponent,
        LoadPublicComponentFromComponents: this.replayLoadPublicComponent,
        PlacePublicComponentFromComponents: this.replayPlacePublicComponent,
        LoadPublicComponentInBatchFromComponents: this.replayLoadPublicComponentInBatch,
      }
      actionResult = actionMethodsMapping[actionName] ? await actionMethodsMapping[actionName](actionArgs) : {
        code: 'failure',
        message: "unknown action name '" + actionName + "'",
        data: false
      }
      CompleteReplayJournal(actionName, actionResult).catch()
    },

    async handleReplayJournalPrecheck(params) {
      const actionName = params.actionName
      const actionArgs = params.actionArgs
      console.log("prechecking replaying journal action '" + actionName + "' with args:\r\n" + JSON.stringify(actionArgs))
      console.log('readyState', document.readyState)
      const precheckResult = {
        isReady: document.readyState === 'complete',
        reason: ''
      }
      ConfirmReplayJournalPrecheck(actionName, precheckResult).catch()
    },
    // 需要登录后才能进入的页面，进行页面跳转
    async goPageAfterLogin(routeInfo) {
      const isLogin = await this.checkLogin()
      if (isLogin) {
        this.toPage(routeInfo)
      } else {
        await this.showLoginDialog()
      }
    },
    replayGoToProductListPage(args) {
      return new Promise((resolve) => {
        window.replayProductListCallback = () => {
          resolve({
            code: 'success',
            data: true
          })
          window.replayProductListCallback = null
        }
        this.goPageAfterLogin(args).catch()
      })
    },
    replayGoToProductDetailPage(args) {
      return new Promise((resolve) => {
        window.replayProductDetailCallback = () => {
          resolve({
            code: 'success',
            data: true
          })
          window.replayProductDetailCallback = null
        }
        this.goPageAfterLogin(args).catch()
      })
    },
    replayGoToSelectionListPage(args) {
      return new Promise((resolve) => {
        window.replaySelectionListCallback = () => {
          resolve({
            code: 'success',
            data: true
          })
          window.replaySelectionListCallback = null
        }
        this.goPageAfterLogin(args).catch()
      })
    },
    
    async replayLoadPublicComponent(args) {
      const { code } = await LoadPublicComponent(args)
      return code === 'success' ? { code: 'success', data: true } : { code: 'failure', message: 'actionName:LoadPublicComponent Failed', data: false }
    },
    async replayPlacePublicComponent(args) {
      const { publicComponent: params, familyTypeToBePlaced: familyType } = args
      const { code } = await PlacePublicComponent(params, familyType)
      return code === 'success' ? { code: 'success', data: true } : { code: 'failure', message: 'actionName:PlacePublicComponent Failed', data: false }
    },
    async replayLoadPublicComponentInBatch(args) {
      const { code } = await LoadPublicComponentInBatch(args)
      return code === 'success' ? { code: 'success', data: true } : { code: 'failure', message: 'actionName:replayLoadPublicComponentInBatch Failed', data: false }
    },
  }
}
